import React from 'react';
import OurTools from 'components/molecules/our_tools';
import DashboardSession from 'components/organisms/dashboard_session';
import NewsSession from 'components/organisms/news_session';
import OpportunitiesSession from 'components/organisms/opportunities_session';

const InactiveDashboard = () => (
  <>
    <div className="row mb-4">
      <div className="col-md-12">
        <OurTools featuredTool />
      </div>
    </div>
    <div className="row mb-4">
      <div className="col-md-12">
        <DashboardSession />
      </div>
    </div>
    <div className="row mb-4">
      <div className="col-md-12">
        <NewsSession />
      </div>
    </div>
    <div className="row mb-4">
      <div className="col-md-12">
        <OpportunitiesSession />
      </div>
    </div>
  </>
);

export default InactiveDashboard;
